import { render, staticRenderFns } from "./role-source.vue?vue&type=template&id=41dcab09&scoped=true&"
import script from "./role-source.vue?vue&type=script&lang=js&"
export * from "./role-source.vue?vue&type=script&lang=js&"
import style0 from "./role-source.vue?vue&type=style&index=0&id=41dcab09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dcab09",
  null
  
)

export default component.exports